import {getMethod,download} from './data'
import request from '@/utils/request'
export function getqrcode(data) {
    return getMethod('/api/userPoster/qrCode',data)
}
// 海报分类 posterCategory
export function posterCategory(data) {
    return getMethod('/api/posterCategory',data)
}
// 海报列表 poster
export function poster(data) {
    return getMethod('/api/poster',data)
}
// userPoster 用户海报
export function userPoster(data) {
    return getMethod('/api/userPoster',data)
}
// 生成用户海报
export  function adduserPoster(data) {
    return request({
        url: '/api/userPoster' ,
        method: 'post',
        data
    })
}
// 海报详情
export function posterdetail(data){
    return request({
        url:'/api/poster/'+data,
        method: 'get',
    })
}